import { createFileRoute } from "@tanstack/react-router";
import { DatacentrePage, datacentreHead } from "@/pages/DatacentrePage";

export const Route = createFileRoute("/en/industries/data-centers")({
  head: () => datacentreHead("en"),
  component: () => <DatacentrePage locale="en" />,
});
